// Borrower-resolvable credit-pull block reasons forwarded from the API on a failed credit pull
// (meta.creditBlockStatus on the borrower pull; an errors[].key on a 422 guest pull).
// Mirrors the backend App\Libs\Enums\CreditBlockStatus enum.
//   CREDIT_LOCKED  -> account locked screen (go to Experian dashboard to unlock, retry)
//   CREDIT_ON_HOLD -> security freeze screen (go to Experian freeze center to unfreeze, retry)
//   FRAUD_ALERT    -> "we couldn't pull it, but you can still continue" screen
//   NO_RECORD_FOUND -> form re-entry to re-verify identity
// Anything else (or null) => the generic credit error.
export const CREDIT_BLOCK_STATUS = {
  CREDIT_LOCKED: 'CREDIT_LOCKED',
  CREDIT_ON_HOLD: 'CREDIT_ON_HOLD',
  FRAUD_ALERT: 'FRAUD_ALERT',
  NO_RECORD_FOUND: 'NO_RECORD_FOUND',
}

// Experian destinations for the locked/frozen resolution screens.
export const EXPERIAN_LOCKED_URL = 'https://usa.experian.com/mfe/dashboard'
export const EXPERIAN_FROZEN_URL = 'https://www.experian.com/help/credit-freeze/'
